import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_EASTER_70: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_EASTER_70,
  },
  {
    pageId: PageId.CHAT_UPSELL_EASTER_70,
  },
  {
    pageId: PageId.UPSELL_EASTER_70,
  },
  {
    pageId: PageId.DOWNLOAD_EASTER_70,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
